<template>
  <a
    class="scrollactive-item tab"
    :class="[{ active }, size]"
    :data-section-selector="to"
    :href="to"
    @click="emit('tab:click')"
  >
    <slot />
  </a>
</template>

<script setup>
// Emitter
const emit = defineEmits([
  'tab:click',
])

// Props
const props = defineProps({
  active: {
    default() {
      return false
    },
    required: false,
    type: Boolean,
  },
  size: {
    default() {
      return 'l'
    },
    required: false,
    type: String,
    validator(value) {
      return ['m', 'l'].indexOf(value) !== -1
    },
  },
  to: {
    default() {
      return null
    },
    required: false,
    type: String,
  },
})
</script>

<style lang="postcss" scoped>
.tab {
  @apply flex items-center h-16 font-normal text-grey-blue-600 text-origin cursor-pointer border-b-4 border-transparent;

  &.active {
    @apply font-medium text-winter-green-900 border-livestorm-blue-700 cursor-default;
  }

  &.m {
    @apply text-sm;
  }

  &.l {
    @apply text-origin;
  }
}
</style>
